module.exports = __webpack_public_path__ + "static/media/21.2489c382.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/21.png
// module id = 1460
// module chunks = 0